/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Injectable } from '@angular/core';
import { StageAdminService } from '@shared-angular/services/stage-admin.service';
import { FileUploadService } from 'src/app/shared/services/file-upload.service';
import { RouteShareService } from 'src/app/shared/services/route-share.service';

import { GptChatModelTypeArr } from '@shared/index';
import { GroupchatChannelRegistryService } from 'src/app/shared/services/groupchat-channel-registry.service';
import { OVERLAY_PLACEMENT } from './blockly-categories/overlays.category';
import { BlocklyHelperService } from './blockly-helper.service';
import { BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from './blocky-types.types';
import { registerGroupchatChannelDropdownBlock } from './field-groupchat-channel-dropdown';


@Injectable({
  providedIn: 'root'
})
export class BlockkyRAGAIManagersService {
  public gptModels = GptChatModelTypeArr;

  constructor(private BH: BlocklyHelperService, private stageAdmin: StageAdminService, private files: FileUploadService, private rss: RouteShareService) { }
  public label(name: string) {
    return this.BH.label(name);
  }

  public getStackProcessItems(): { checkType: string, text: string, options: string[] }[] {
    return [
      { checkType: 'IMAGE', text: 'Bild', options: this.rss._allImageSkills() },
      { checkType: 'DOCUMENT', text: 'Dokument', options: this.rss._allDokuments() },
      { checkType: 'WEBHOOK', text: 'Webbhook', options: this.rss._allWebhooks() },
      { checkType: 'DATABASE', text: 'Datenbank', options: this.rss._allDataBases() },
      { checkType: 'WENNDANN', text: 'Wenn-Dann', options: this.rss._allWennDann() },
      { checkType: 'ONLINESOURCE', text: 'Onlinequellen', options: this.rss._allOnlineSources() },
      { checkType: 'OFFLINEWEBSITE', text: 'Offline-Websites', options: this.rss._allOfflineWebsites() }
    ];
  }


  public AdobeConnectBlocks(name: string = "ADOBECONNECT"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };

    const connectFunctions = [
      'Mein Benutzername (myUserName)|myUserName()',
      'Mein voller Name (myUserFullName)|myUserFullName()',
      'Meine Benutzer-ID (myUserId)|myUserId()',
      'Meine Rolle (myUserRole)|myUserRole()',
      'Ausgewähltes Layout (selectedLayout)|selectedLayout()',
      'Aufnahme aktiv? (isRecording)|isRecording()',
      'Aufnahme-Status (getRecordingPlayState)|getRecordingPlayState()',
      'Im Add-in? (isAddin)|isAddin()',
      'Raum-URL (getRoomUrl)|getRoomUrl()',
      'Pod-Titel (getPodTitle)|getPodTitle()',
      'Raum-SCO-ID (getRoomSCOID)|getRoomSCOID()',
      'Benutzerliste (getUserList)|getUserList()',
      'Anzahl Benutzer (getUserCount)|getUserCount()',
      'Teilnehmerliste (getParticipants)|getParticipants()',
      'Anzahl Teilnehmer (getParticipantsCount)|getParticipantsCount()',
      'Presenterliste (getPresenters)|getPresenters()',
      'Anzahl Presenter (getPresentersCount)|getPresentersCount()',
      'Hostliste (getHosts)|getHosts()',
      'Anzahl Hosts (getHostsCount)|getHostsCount()'
    ];

    cat.contents = [
      this.label("ADOBECONNECT"),
      this.BH.ragAi("ADOBECONNECT_FUNCTIONS", "@output:String\nRAGAI.ADOBECONNECT.{{key:dropdown=" + connectFunctions.join(",") + "}}", "await RAGAI.ADOBECONNECT.{{key}}"),
      this.BH.ragAi("ADOBECONNECT_DISPATCHSYNCMESSAGE", "RAGAI.ADOBECONNECT.dispatchSyncMessage({{msgName}},{{msgValue}})", "RAGAI.ADOBECONNECT.dispatchSyncMessage({{msgName}},{{msgValue}});")
    ];
    return cat;
  }

  public SCORMBlocks(name: string = "SCORM"): BlocklyToolboxCategory {
    const scormFields = [
      'cmi.core.student_name',
      'cmi.core.student_id',
      'cmi.core.score.raw',
      'cmi.core.score.min',
      'cmi.core.score.max',
      'cmi.core.lesson_location',
      'cmi.core.lesson_status',
      'cmi.interactions._count',
      'cmi.suspend_data'];

    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.ragAi("SCORM_GET", "@output:String\nSCORM.get({{key:dropdown=" + scormFields.join(",") + "}})", "await RAGAI.SCORM.LMSGetValue('{{key}}')"),
      this.BH.withNested(
        this.BH.ragAi("SCORM_SET", "SCORM.set({{key:dropdown=" + scormFields.join(",") + "}},{{val}})", "await RAGAI.SCORM.LMSSetValue('{{key}}', {{val}});\n")
        , [{ forValue: "val", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
      ),

      this.BH.ragAi("SCORM_ISIINIT", "@output:String\nSCORM.LMSIsInitialized()", "await RAGAI.SCORM.LMSIsInitialized()"),
      this.BH.ragAi("SCORM_INIT", "SCORM.LMSInitialize()", "await RAGAI.SCORM.LMSInitialize();\n"),
      this.BH.ragAi("SCORM_COMMIT", "SCORM.LMSCommit()", "await RAGAI.SCORM.LMSCommit();\n"),
      this.BH.ragAi("SCORM_FINISH", "SCORM.LMSFinish()", "await RAGAI.SCORM.LMSFinish();\n")

    ];
    return cat;
  }


  public DownloadBlocks(name: string = "Up/Download"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label("Download"),

      this.BH.withNested(
        this.BH.ragAi("RAGAI_DOWNLOAD", "Textdatei mit Inhalt herunterladen\nInhalt: {{fileContent}}\nDateiname: {{fileName}}", "await RAGAI.DOWNLOAD.textAsFile({{fileContent}},{{fileName}});"),
        [
          { forValue: "fileContent", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "fileName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "download.txt" } }
        ]
      ),
      this.BH.withNested(
        this.BH._custom(
          "DOWNLOAD_FILLED_TEMPLATE",
          "Ausgefüllte Vorlage herunterladen:\nVorlage:{{skillId}}\nDateiname:{{dateiName:text=meineDatei.docx}}\n\nPlatzhalter: {{platzhalter:statement}}\n", "await RAGAI.DOWNLOAD.downloadFilledTemplate({{skillId}}, {{dateiName}}, { {{platzhalter}} });")
        ,
        [
          { forValue: "skillId", isShadow: true, targetBlockType: 'BLOCK_STACK_DOCUMENT' },
          { forValue: "platzhalter", isShadow: true, targetBlockType: 'TEMPLATE_VALUE' },
        ]
      ),
      this.BH.withNested(
        this.BH._custom("TEMPLATE_VALUE", "Ersetze Platzhalter{{key:text=name}} durch den Wert: {{value}}", "{{key}}: {{value}}, ", { colour: BLOCKLY_COLORS.RAGAI, inputsInline: true }),
        [
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Max Mustermann" } },
        ]
      ),

      this.label("Upload"),
      this.BH.withNested(
        this.BH.overlay(
          "OVERLAY_UPLOAD_TXT_ADVANCED",
          "Upload Anfordern:\nTitel:{{text}}\nHinweis:{{instruktion}}\n\nnach Upload: {{?action:statement}}\n" + OVERLAY_PLACEMENT, "await RAGAI.OVERLAY.setPlacement({{placement}});\n await RAGAI.OVERLAY.uploadFile({{text}},{{instruktion}},async function(fileContent,fileName,fileType){ {{action}} });")
        ,
        [{
          forValue: 'instruktion',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Datei hierher ziehen (.txt oder textbasiert)" }
        },
        {
          forValue: 'text',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Datei hochladen" }
        }
        ]
      ),
      this.label("Eigenschaften & Werte "),
      this.BH.propertyDropdown("UPLOADFILE_PROPERITES", "Hochgeladene Datei: ", [
        ["Name", "fileName"],
        ["Inhalt", "fileContent"],
        ["Typ", "fileType"]
      ])
    ];
    return cat;
  }

  public KEYVALCombinedBlocks(name: string = "Datenspeicher"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    const externalStyle = { colour: BLOCKLY_COLORS.RAGAI, inputsInline: true };
    cat.contents = [
      this.label("🤖 Bot-bezogen"),
      this.BH.withNested(
        this.BH._custom("KEYVAL_SET_V2", "Für {{type:dropdown=Bot|,Projekt|PROJECT}} setze Wert {{value}} als {{key}} in Gruppe {{?group}}", "await RAGAI.{{type}}KEYVAL.set({{key}}, {{value}}, {{group}});", externalStyle),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Name" } },
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Max Mustermann" } },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
        ]
      ),
      this.BH.withNested(
        this.BH._custom("KEYVAL_GET_V2", "@output:String\n Für {{type:dropdown=Bot|,Projekt|PROJECT}} hole Wert: {{key}} aus Gruppe: {{?group}}", "await RAGAI.{{type}}KEYVAL.get({{key}}, {{group}})", externalStyle),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Name" } },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
        ]
      ),
      this.label("---"),
      this.BH.withNested(
        this.BH._custom("KEYVAL_UNIQUE_V2", "Für {{type:dropdown=Bot|,Projekt|PROJECT}}Wert: {{value}}  zur Gruppe: {{group}} hinzufügen", "await RAGAI.{{type}}KEYVAL.unique('unique_', {{value}}, {{group}});", externalStyle),
        [
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Max Mustermann" } },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
        ]
      ),

      this.BH.withNested(
        this.BH._custom("KEYVAL_GET_COLLECTION_VALUES_V2", "@output:String\nFür {{type:dropdown=Bot|,Projekt|PROJECT}} hole Werte aus Gruppe: {{group}} Trennzeichen {{?seperator}}", "(await RAGAI.{{type}}KEYVAL.getByType({{group}})).map(e => e.value).join({{seperator}})", externalStyle),
        [
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } },
          { forValue: "seperator", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "<br>" } }
        ]
      )

    ];

    // Alte Blöcke nur registrieren (Abwärtskompatibilität)
    this.BH.withNested(
      this.BH._custom("KEYVAL_GET_COLLECTION_TEXT_V2", "@output:String\nAlle Werte als Text aus Gruppe: {{group}}", "(await RAGAI.KEYVAL.getByType({{group}})).map(e => e.value).join('\\n')", externalStyle),
      [{ forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }]
    );
    this.BH.withNested(
      this.BH.ragAi("PROJECTKEYVAL_SET_V2", "(Projekt) - setze Wert: {{value}} als {{key}} in Gruppe {{?group}}", " await RAGAI.PROJECTKEYVAL.set({{key}}, {{value}},{{group}});"),
      [
        { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Max Mustermann" } },
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Name" } },
        { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
      ]
    );
    this.BH.withNested(
      this.BH.ragAi("PROJECTKEYVAL_GET_V2", "@output:String\n(Projekt) - Hole Wert: {{key}} aus Gruppe: {{?group}}", "await RAGAI.PROJECTKEYVAL.get({{key}},{{group}})"),
      [
        { forValue: "key", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Schlüssel" } },
        { forValue: "group", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
      ]
    );
    this.BH.withNested(
      this.BH.ragAi("PROJECTKEYVAL_UNIQUE_V2", "(Projekt) - Wert: {{value}} zur Gruppe: {{group}} hinzufügen", " await RAGAI.PROJECTKEYVAL.unique('unique_', {{value}},{{group}});"),
      [
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Wert" } },
        { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Meine Gruppe" } }
      ]
    );
    this.BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_VALUES_V2", "@output:String\nPROJECTKEYVAL.getCollectionValues({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value)");
    this.BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_TEXT_V2", "@output:String\nPROJECTKEYVAL.getCollectionText({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value).join('\\n')");
    // Alte KEYVAL/PROJECTKEYVAL-Blöcke werden in deprecated.category.ts registriert

    return cat;
  }

  public KEYVALBlocks(name: string = "KEYVAL"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH.ragAi("KEYVAL_SET", "KEYVAL.set({{key}}, {{value}}, {{group}})", " await RAGAI.KEYVAL.set({{key}}, {{value}},{{group}});"),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Collection" } }
        ]
      ),
      this.BH.withNested(
        this.BH.ragAi("KEYVAL_UNIQUE", "KEYVAL.unique({{key}}, {{value}}, {{group}})", " await RAGAI.KEYVAL.unique({{key}}, {{value}},{{group}});"),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Collection" } }
        ]
      ),
      this.BH.withNested(
        this.BH.ragAi("KEYVAL_GET", "@output:String\nKEYVAL.get({{key}},{{group:text=Collection}})", "await RAGAI.KEYVAL.get({{key}},{{group}})"),
        [{ forValue: "key", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      ),
      this.BH.ragAi("KEYVAL_GET_COLLECTION_VALUES", "@output:String\nKEYVAL.getCollectionValues({{group:text=Collection}})", "(await RAGAI.KEYVAL.getByType({{group}})).map(e => e.value)"),
      this.BH.ragAi("KEYVAL_GET_COLLECTION_TEXT", "@output:String\nKEYVAL.getCollectionText({{group:text=Collection}})", "(await RAGAI.KEYVAL.getByType({{group}})).map(e => e.value).join('\\n')")
    ];
    return cat;
  }

  public PROJECTKEYVALBlocks(name: string = "PROJECTKEYVAL"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH.ragAi("PROJECTKEYVAL_SET", "PROJECTKEYVAL.set({{key}}, {{value}}, {{group}})", " await RAGAI.PROJECTKEYVAL.set({{key}}, {{value}},{{group}});"),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Collection" } }
        ]
      ),
      this.BH.withNested(
        this.BH.ragAi("PROJECTKEYVAL_UNIQUE", "PROJECTKEYVAL.unique({{key}}, {{value}}, {{group}})", " await RAGAI.PROJECTKEYVAL.unique({{key}}, {{value}},{{group}});"),
        [
          { forValue: "key", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "group", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Collection" } }
        ]
      ),
      this.BH.withNested(
        this.BH.ragAi("PROJECTKEYVAL_GET", "@output:String\nPROJECTKEYVAL.get({{key}},{{group:text=Collection}})", "await RAGAI.PROJECTKEYVAL.get({{key}},{{group}})"),
        [{ forValue: "key", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      ),
      this.BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_VALUES", "@output:String\nPROJECTKEYVAL.getCollectionValues({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value)"),
      this.BH.ragAi("PROJECTKEYVAL_GET_COLLECTION_TEXT", "@output:String\nPROJECTKEYVAL.getCollectionText({{group:text=Collection}})", "(await RAGAI.PROJECTKEYVAL.getByType({{group}})).map(e => e.value).join('\\n')")
    ];
    return cat;
  }

  public GroupchatBlocks(name: string = "Bot-to-Bot-Nachricht", registry: GroupchatChannelRegistryService): BlocklyToolboxCategory {
    registerGroupchatChannelDropdownBlock(registry);
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    const kiStyle = { colour: BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, inputsInline: true };
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH._custom("GROUPCHAT_SEND", "Nachricht in Gruppenchat senden:{{nachricht}} in Kanal {{kanal}}", "await RAGAI.GROUPCHAT.send({{nachricht}}, {{kanal}});", kiStyle),
        [
          { forValue: "nachricht", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }
        ]
      ),
      this.BH.withNested(
        this.BH._custom("GROUPCHAT_READ", "@output:String\nGruppenchatverlauf auslesen:{{kanal}}", "await RAGAI.GROUPCHAT.read({{kanal}})", kiStyle),
        [{ forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }]
      ),
      this.BH.withNested(
        this.BH._custom("GROUPCHAT_DELETE", "Gruppenchat löschen:{{kanal}}", "await RAGAI.GROUPCHAT.delete({{kanal}});", kiStyle),
        [{ forValue: "kanal", isShadow: true, targetBlockType: 'GROUPCHAT_CHANNEL_DROPDOWN' }]
      )
    ];
    return cat;
  }

  public HelperBlocks(name: string = "HELPER"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.ragAi("RAGAI.HELPER.closeWindow", "RAGAI.HELPER.closeWindow()", "RAGAI.HELPER.closeWindow();"),
      this.BH.withNested(
        this.BH.ragAi("RAGAI.HELPER.copyToClipboard", "RAGAI.HELPER.copyToClipboard({{text}})", "RAGAI.HELPER.copyToClipboard({{text}});"),
        [{ forValue: "text", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
      ),
      this.BH.withNested(
        this.BH.ragAi("HELPER_ADDSTAT", "📊 Statistik-Messpunkt: {{stat}}", "await RAGAI.HELPER.addStat({{stat}});"),
        [{ forValue: "stat", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    ];
    return cat;
  }

  public toastrBlocks(name: string = "toastr"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    this.BH._custom("OPTIONS_DUMMY", "@output:T_OPTION\n⚙️", "{}", { colour: BLOCKLY_COLORS.RAGAI_DARK });
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH.ragAi("toastr_SUCCESS", "toastr.success({{ title }}, {{ msg }}, {{ options[@check=T_OPTION] }}) ", "RAGAI.toastr.success({{ title }}, {{ msg }}, {{ options }}); "),
        [{ forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "msg", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "options", isShadow: true, targetBlockType: 'OPTIONS_DUMMY' }]
      ),
      this.BH.withNested(
        this.BH.ragAi("toastr_ERROR", "toastr.error({{ title }}, {{ msg }}, {{ options[@check=T_OPTION] }}) ", "RAGAI.toastr.error({{ title }}, {{ msg }}, {{ options }}); "),
        [{ forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "msg", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "options", isShadow: true, targetBlockType: 'OPTIONS_DUMMY' }]
      ),
      this.BH.withNested(
        this.BH.ragAi("toastr_INFO", "toastr.info({{ title }}, {{ msg }}, {{ options[@check=T_OPTION] }}) ", "RAGAI.toastr.info({{ title }}, {{ msg }}, {{ options }}); "),
        [{ forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "msg", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "options", isShadow: true, targetBlockType: 'OPTIONS_DUMMY' }]
      ),
      this.BH.withNested(
        this.BH.ragAi("toastr_WARNING", "toastr.warning({{ title }}, {{ msg }}, {{ options[@check=T_OPTION] }}) ", "RAGAI.toastr.warning({{ title }}, {{ msg }}, {{ options }}); "),
        [{ forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "msg", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING }, { forValue: "options", isShadow: true, targetBlockType: 'OPTIONS_DUMMY' }]
      ),
      this.BH._custom(
        `toastr_options`,
        `@output:T_OPTION
        ⚙️
        closeButton {{ closeButton:checkbox }}
        timeOut {{ timeOut:number=5000 }} ms
        extendedTimeOut {{ extendedTimeOut:number=1000 }} ms
        disableTimeOut {{ disableTimeOut:checkbox }}
        easeTime {{ easeTime:number=300 }} ms
        enableHtml {{ enableHtml:checkbox }}
        newestOnTop {{ newestOnTop:checkbox=true }}
        progressBar {{ progressBar:checkbox }}
        progressAnimation {{ progressAnimation:dropdown='decreasing','increasing' }}
        positionClass {{ positionClass:dropdown='toast-top-right','toast-top-left','toast-top-full-width','toast-top-center','toast-bottom-right','toast-bottom-left','toast-bottom-full-width','toast-bottom-center' }}
        tapToDismiss {{ tapToDismiss:checkbox=true }}
        `,
        `{
  closeButton: {{ closeButton }},
  timeOut: {{ timeOut }},
  extendedTimeOut: {{ extendedTimeOut }},
  disableTimeOut: {{ disableTimeOut }},
  easeTime: {{ easeTime }},
  enableHtml: {{ enableHtml }},
  newestOnTop: {{ newestOnTop }},
  progressBar: {{ progressBar }},
  progressAnimation: {{ progressAnimation }},
  positionClass: {{ positionClass }},
  tapToDismiss: {{ tapToDismiss }}
}`,
        { colour: BLOCKLY_COLORS.RAGAI_DARK }
      )
    ];
    return cat;
  }

  public AUDIOBlocks(name: string = "AUDIO"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH.ragAi(
          "AUDIO_botSay",
          `AUDIO.botSay({{msg}})`,
          `await RAGAI.AUDIO.botSay({{msg}});`
        ),
        [{ forValue: 'msg', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Dies ist ein Demo-Text" } }]
      )
    ];
    return cat;
  }

  public WEBHOOKBlocks(name: string = "WEBHOOK"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    this.BH._custom("OPTIONS_DUMMY_WH", "@output:WH_OPTION\n⚙️", "{}", { colour: BLOCKLY_COLORS.RAGAI_DARK });
    cat.contents = [
      this.label(name),
      this.BH.withNested(
        this.BH.ragAi("WEBHOOK_CALL", "Webhook aufrufen:\nWebhook: {{ skillId[@check=WEBHOOK] }}\nDaten: {{ data[@check=RAGAIOBJ] }}", " await RAGAI.WEBHOOK.call({{skillId}}, {{data}});"),
        [
          { forValue: "skillId", isShadow: true, targetBlockType: 'BLOCK_STACK_WEBHOOK' },
          { forValue: "data", isShadow: true, targetBlockType: BLOCKLY_DUMMY.RAGAIOBJ, targetBlockDefaults: { obj: '{"key1":"value", "key2":"value"}' } }
        ]
      ),

      /*this.BH._custom(
        `webhook_JSONoptions`,
        `@output:WH_JSON_OPTION
        ⚙️
        JSON {{ json:text }}
        `,
        `{ {{json}} }`,
        { colour: BLOCKLY_COLORS.YELLOW }
      )*/
    ];
    return cat;
  }

  public INFOBlocks(name: string = "INFO"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH._custom("INFO_MESSAGECOUNT", "@output:Number\nNachrichtenanzahl", `RAGAI.INFO.messagesCount()`, { colour: BLOCKLY_COLORS.PROPERTIES })
    ];
    return cat;
  }


  public AITEXT_OPENAIBlocks(name: string = "AITEXT_OPENAI"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.BH.withNested(
        this.BH.ragAi("AITEXT_CHATCOMPLETION", `@output:String\nAntwort eines LLM:
  Prompt: {{prompt}}  Model: {{model:dropdown=${this.gptModels.join(",")}}}  Temperatur: {{?temp}}  Websuche: {{?webSearch}}`, "await RAGAI.AITEXT_OPENAI.chatCompletion({{prompt}}, '{{model}}', {{temp}}, {{webSearch}})"),
        [
          { forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "temp", isShadow: false, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0.7 } },
          { forValue: "webSearch", isShadow: false, targetBlockType: BLOCKLY_DUMMY.BOOLEAN, targetBlockDefaults: { value: false } }
        ]
      ),

      // ── Strukturierte KI-Analyse ─────────────────────────────────────
      this.BH.label("Strukturierte KI-Analyse"),

      // Hauptblock: sammelt Schema-Felder via Statement-Stacking
      this.BH.withNested(
        this.BH._custom("AITEXT_STRUCTURED_RESPONSE",
          `@output:String\n🧠 Strukturierte KI-Analyse
  Analysiere: {{promptInput}}
  Anweisung: {{?instructions}}
  Model: {{model:dropdown=${this.gptModels.join(",")}}}  Temperatur: {{?temp}}  Websuche: {{?webSearch:checkbox=false}}
  ──────────
  Kriterien: {{fields:statement[@check=SCHEMA_FIELD]}}`,
          `await (async function(){var _p=Object.assign({},...[{{fields}}].filter(function(x){return typeof x==="object"}));return await RAGAI.AITEXT_OPENAI.structuredResponse({promptInput:{{promptInput}},jsonSchema:{name:"structured_response",schema:{type:"object",properties:_p,required:Object.keys(_p),additionalProperties:false}},model:"{{model}}",temperature:{{temp}},instructions:{{instructions}},webSearch:{{webSearch}}});})()`,
          { colour: BLOCKLY_COLORS.CAT_KI_FUNKTIONEN, connection: 'none' }
        ),
        [
          { forValue: "promptInput", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "instructions", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Analysiere objektiv" } },
          { forValue: "temp", isShadow: false, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0.2 } }
        ]
      ),

      // Schema-Feld: Kriterium (Ja/Nein + Begründung) – häufigstes Pattern
      this.BH._custom("SCHEMA_FIELD_CRITERION",
        `✅ Kriterium mit Bewertung"{{key:text=A}}" Frage: "{{description:text=War die Begrüßung nett?}}"`,
        `{[{{key}}]:{type:"object",properties:{isTrue:{type:"boolean",description:{{description}}},reason:{type:"string",description:"Begründung"}},required:["isTrue","reason"],additionalProperties:false}},`,
        { colour: '#7E57C2', previousStatement: 'SCHEMA_FIELD', nextStatement: 'SCHEMA_FIELD', inputsInline: true }
      ),

      // Schema-Feld: Text
      this.BH._custom("SCHEMA_FIELD_STRING",
        `📝 Textfeld "{{key:text=zusammenfassung}}" Beschreibung: "{{description:text=Kurze Zusammenfassung}}"`,
        `{[{{key}}]:{type:"string",description:{{description}}}},`,
        { colour: '#9575CD', previousStatement: 'SCHEMA_FIELD', nextStatement: 'SCHEMA_FIELD', inputsInline: true }
      ),

      // Schema-Feld: Zahl
      this.BH._custom("SCHEMA_FIELD_NUMBER",
        `🔢 Zahlenfeld "{{key:text=punkte}}" Beschreibung: "{{description:text=Bewertung 1-10}}"`,
        `{[{{key}}]:{type:"number",description:{{description}}}},`,
        { colour: '#9575CD', previousStatement: 'SCHEMA_FIELD', nextStatement: 'SCHEMA_FIELD', inputsInline: true }
      ),

      // Schema-Feld: Ja/Nein
      this.BH._custom("SCHEMA_FIELD_BOOLEAN",
        `⬜ Ja/Nein-Feld "{{key:text=hatGekauft}}" Beschreibung: "{{description:text=Wurde etwas verkauft?}}"`,
        `{[{{key}}]:{type:"boolean",description:{{description}}}},`,
        { colour: '#9575CD', previousStatement: 'SCHEMA_FIELD', nextStatement: 'SCHEMA_FIELD', inputsInline: true }
      ),

      // Feld aus der Antwort einer strukturierten KI-Analyse auslesen (typkorrekt gecastet)
      this.BH.withNested(
        this.BH._custom("AITEXT_STRUCTURED_RESPONSE_FIELD",
          `@output:String\n🔎 Feld "{{key:text=A}}" (Typ: {{type:dropdown=Text|string,Zahl|number,Ja/Nein|boolean,Kriterium: Ist wahr|isTrue,Kriterium: Begründung|reason}}) aus Antwort {{json}}`,
          `(function(o,p,t){var v=p.split('.').reduce(function(a,k){return a?.[k]},o);if(t==='isTrue')return Boolean(v&&v.isTrue);if(t==='reason')return String((v&&v.reason)??'');if(t==='number')return Number(v);if(t==='boolean')return Boolean(v);return v==null?'':String(v);})({{json}},{{key}},'{{type}}')`,
          { colour: BLOCKLY_COLORS.PROPERTIES, inputsInline: true }
        ),
        [{ forValue: "json", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: '{"A":{"isTrue":true,"reason":""},"punkte":0}' } }]
      ),
    ];

    // Deprecated: nur registrieren für bestehende Workspaces
    this.BH.withNested(
      this.BH.ragAi("AITEXT_OPENAI_CHATCOMPLESION", `RAGAI.AITEXT_OPENAI.chatCompletion(
  prompt: {{prompt}},
  model: {{model:dropdown=${this.gptModels.join(",")}}},
  temperature: {{temp}},
  webSearch: {{webSearch}}
)`, "await RAGAI.AITEXT_OPENAI.chatCompletion({{prompt}}, '{{model}}', {{temp}}, {{webSearch}});"),
      [
        { forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "temp", isShadow: false, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0.7 } },
        { forValue: "webSearch", isShadow: false, targetBlockType: BLOCKLY_DUMMY.BOOLEAN, targetBlockDefaults: { value: false } }
      ]
    );
    this.BH.withNested(
      this.BH.ragAi("AITEXT_OPENAI_CHATCOMPLETIONJSON", `RAGAI.AITEXT_OPENAI.chatCompletionJson(
  prompt: {{prompt}},
  model: {{model:dropdown=${this.gptModels.join(",")}}},
  temperature: {{temp}},
  webSearch: {{webSearch}}
)`, "await RAGAI.AITEXT_OPENAI.chatCompletionJson({{prompt}}, '{{model}}', {{temp}}, {{webSearch}});"),
      [
        { forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: "temp", isShadow: false, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0.7 } },
        { forValue: "webSearch", isShadow: false, targetBlockType: BLOCKLY_DUMMY.BOOLEAN, targetBlockDefaults: { value: false } }
      ]
    );

    return cat;
  }

  public WAITFORBlocks(name: string = "WAITFOR"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [
      this.label(name),
      this.BH.ragAi("WAITFOR_NEXTIDLE", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.nextIdle()", "await RAGAI.WAITFOR.nextIdle();"),
      this.BH.ragAi("WAITFOR_INITIDLE", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.initialIdle()", "await RAGAI.WAITFOR.initialIdle();"),
      this.BH.ragAi("WAITFOR_SCORMINITED", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.scormInited()", "await RAGAI.WAITFOR.scormInited();"),

      this.BH.ragAi("WAITFOR_INITVARS", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.varsInit()", "await RAGAI.WAITFOR.varsInit();"),
      this.BH.withNested(
        this.BH.ragAi("WAITFOR_EVENT", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.event({{ hook[@check=EVENT] }})", "await RAGAI.WAITFOR.event({{ hook }});"),
        [{ forValue: "hook", isShadow: true, targetBlockType: 'EVENT_ALL' }]
      ),
      this.BH.withNested(
        this.BH.ragAi("WAITFOR_SECONDS", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.seconds({{sec[@check:Number]}})", "await RAGAI.WAITFOR.seconds({{sec}});"),
        [{ forValue: "sec", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
      ),
      this.BH.withNested(
        this.BH.ragAi("WAITFOR_MINUTES", BLOCKLY_CARD_PREFIX.WAITFOR + "WAITFOR.minutes({{min[@check:Number]}})", "await RAGAI.WAITFOR.minutes({{min}});"),
        [{ forValue: "min", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
      )
    ];
    return cat;
  }

  ///
  public playgroundBlocks(name: string = "unnamed"): BlocklyToolboxCategory {
    const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
    cat.contents = [];



    //EXTRAS
    cat.contents.push(this.BH._custom("CONFETTI", "Confetti", "RAGAI.confetti();"));
    cat.contents.push(this.BH._custom("CANCLE_BOT", "Bot-Denken abbrechen", "RAGAI.cancel();"));
    cat.contents.push(this.BH._custom("BOT_CHANCE", "Bereitstellung der chance API", "RAGAI.chance;"));
    cat.contents.push(this.BH._custom("BOT_QS", "Bereitstellung der query String API", "RAGAI.qs;"));
    cat.contents.push(this.BH._custom("RESET_BOT", "Bot zurücksetzen", "RAGAI.resetBot();"));
    cat.contents.push(this.BH._custom("RESET_SERVICE", "Gib die ragai zurück", "RAGAI.service;"));


    //NACHRICHTEN
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_ADDMESSAGE", "sende eine Nachricht aus Nutzersicht {{msg}}", "await RAGAI.addMessage({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_ADDMESSAGEBOT", "sende eine Nachricht aus Botsicht {{msg}}", "await RAGAI.addMessageBot({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_BOTBYPASS", "sende eine Nachricht als Bot-Bypass {{msg}}", "await RAGAI.botBypass({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_BOTMESSAGE", "Emittiere eine Nachricht aus Botsicht an das IFrame. {{ msg }} ", "await RAGAI.botMessage({{ msg }}); "),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_RUNMESSAGE", "Emittiere eine Nachricht an das IFrame. {{msg}}", "await RAGAI.runMessage({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_USERMESSAGE", "Emittiere eine Nachricht aus Nutzersicht an das IFrame. {{msg}}", "await RAGAI.userMessage({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("BOT_USERBYPASS", "sende eine Nachricht als Nutzer-Bypass {{msg}}", "await RAGAI.userBypass({{msg}});"),
        [{ forValue: "msg", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );


    //AIIMAGE
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AIIMAGE_OPENAI_CREATE", "OpenAI Bild generieren {{prompt}}", "await RAGAI.AIIMAGE_OPENAI.create({{prompt}});"),
        [{ forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AIIMAGE_OPENAI_GETIMAGEURL", "OpenAI Bildlink mithilfe von ID generieren {{id}}", "await RAGAI.AIIMAGE_OPENAI.getImageUrl({{id}});"),
        [{ forValue: "id", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(this.BH._custom("AIIMAGE_OPENAI_ANALYZEIMAGE", "Analysiere ein Bild \n Bild: {{image:text}} \n Prompt: {{prompt:text}}", "await RAGAI.AIIMAGE_OPENAI.analyzeImage({{image}}, {{prompt}});"));
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AIIMAGE_SD_CREATE", "Stable Diffusion Bild generieren {{prompt}}", "await RAGAI.AIIMAGE_STABLEDIFFUSION.create({{prompt}});"),
        [{ forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AIIMAGE_SD_GETIMAGEURL", "Stable Diffusion Bildlink mithilde von ID generieren {{id}}", "await RAGAI.AIIMAGE_STABLEDIFFUSION.getImageUrl({{id}});"),
        [{ forValue: "id", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );


    //AITEXT
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AITEXT_VLLM_CHATCOMPLESION", "Abweichender Prompt an vLLM {{prompt}}", "await RAGAI.AITEXT_VLLM.chatCompletion({{prompt}});"),
        [{ forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AITEXT_VLLM_CHATCOMPLESIONJSON", "Abweichender Prompt an vLLM mit JSON Rückgabe {{prompt}}", "await RAGAI.AITEXT_VLLM.chatCompletionJson({{prompt}});"),
        [{ forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]
      )
    );

    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("AITEXT_OPENAI_CHATCOMPLESIONJSON", "Abweichender Prompt an OpenAI mit JSON Rückgabe {{prompt}}, {{model:dropdown=" + this.gptModels.join(",") + "}}, {{temp}}", "await RAGAI.AITEXT_OPENAI.chatCompletionJson({{prompt}}, {{model}}, {{temp}});"),
        [
          { forValue: "prompt", isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
          { forValue: "temp", isShadow: false, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0.7 } }
        ]
      )
    );


    //CARDS
    cat.contents.push(
      this.BH.withNested(
        this.BH.card("CARDS_IMAGE", "IMG", "Zeige ein Bild direkt im Chatverlauf an {{url[@check=URL]}}", "await RAGAI.CARDS.image({{url}});"),
        [{ forValue: "url", isShadow: false, targetBlockType: BLOCKLY_DUMMY.URL }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH.card("CARDS_IFRAME", "", "iFrame anzeigen {{url[@check=URL]}}", "await RAGAI.CARDS.iframe({{url}});"),
        [{ forValue: "url", isShadow: false, targetBlockType: BLOCKLY_DUMMY.URL }]
      )
    );
    cat.contents.push();
    cat.contents.push(this.BH.card("CARDS_VIMEO", "VIMEO", "Zeige ein Vimeo Video direkt im Chatverlauf an \n ID: {{id:text}} \n Freigabe.Hash: {{hash:text}} ", "await RAGAI.CARDS.vimeo({{id}}, {{hash}});"));
    cat.contents.push(this.BH.card("CARDS_YOUTUBE", "YOUTUBE", "Zeige ein Youtube Video direkt im Chatverlauf an \n Video-Id: {{id:text}}", "await RAGAI.CARDS.youtube({{id}});"));
    cat.contents.push(this.BH.card("CARDS_STAGELISTBUTTONS", "YOUTUBE", "Stelle die eingestellten Stages als Buttons im Chatverlauf dar", "await RAGAI.CARDS.stageListButtons();"));


    //CHAT_AVATAR
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("SET_BOT_IMAGE", "Setze ein Bot Avatarbild {{skillId[@check=IMAGE]}}", "await RAGAI.CHAT_AVATAR.setBotImg('{{skillId}}');"),
        [{ forValue: "skillId", isShadow: false, targetBlockType: 'BLOCK_STACK_IMAGE' }]
      )
    );
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("SET_USER_IMAGE", "Setze ein Nutzer Avatarbild {{skillId[@check=IMAGE]}}", "await RAGAI.CHAT_AVATAR.setUserImg('{{skillId}}');"),
        [{ forValue: "skillId", isShadow: false, targetBlockType: 'BLOCK_STACK_IMAGE' }]
      )
    );
    cat.contents.push(this.BH._custom("UNSET_BOT_IMAGE", "Entfernt das gesetzte Bot Avatarbild", "await RAGAI.CHAT_AVATAR.unsetBotImg();"));
    cat.contents.push(this.BH._custom("UNSET_USER_IMAGE", "Entfernt das gesetzte Nutzer Avatarbild", "await RAGAI.CHAT_AVATAR.unsetUserImg();"));

    //HELPER
    cat.contents.push(this.BH._custom("HELPER_ADDSTAT", "Füge einen Messpunkt hinzu \n Stat: {{stat:text}}", "await RAGAI.HELPER.addStat({{stat}});"));
    cat.contents.push(this.BH._custom("HELPER_COPYTOCLIPBOARD", "Legt einen Text in die Zwischenablage des Nutzers \n  Text: {{text:text}}", "RAGAI.HELPER.copyToClipboard({{text}});"));
    cat.contents.push(this.BH._custom("HELPER_CLOSEWINDOW", "Schließt das aktuelle Fenster im Browser", "RAGAI.HELPER.closeWindow();"));
    cat.contents.push(this.BH._custom("HELPER_DOWNLOADTEXTASFILE", "Lässt eine Textdatei im Bot herunterladen. \n Inhalt. {{text:text}} \n Dateiname: {{filename:text=text.txt}}", "RAGAI.HELPER.downloadTextAsFile({{text}}, {{filename}});"));
    cat.contents.push(this.BH._custom("HELPER_DOWNLOADMATERIAL", "Lade ein hinterlegtes Dokument herunter \n SkillId: {{skillId:text}}", "await RAGAI.HELPER.downloadMaterial({{skillId}});"));
    cat.contents.push(
      this.BH.withNested(
        this.BH._custom("HELPER_GETIMAGEURL", "Liefere einen Link zum Abruf eines Bildes {{skillId[@check=IMAGE]}}", "await RAGAI.HELPER.getImageURLFromSkill('{{skillId}}');"),
        [{ forValue: "skillId", isShadow: false, targetBlockType: 'BLOCK_STACK_IMAGE' }]
      )
    );
    cat.contents.push(this.BH._custom("HELPER_CURRENTLANGUAGE", "@output:String\nAktuelle Sprache des Bots (z. B. \"de\", \"en\")", "RAGAI.HELPER.currentLanguage()"));

    //KeyVal

    //    cat.contents.push(this.BH.text("TEXT_BLOCK_ID", "🪪"));
    return cat;
  }

}
